import {
  frameThickness,
  glassHingeWidth,
  glassHingeHeight,
  glassLockWidth,
  glassLockHeight,
} from '@/shared/config/model-constants'
import type { ModelData } from '@/shared/stores/model-utils'

export const model6InitialModel: ModelData = {
  name: 'Template 6 - Triple Door System',
  modelId: 'model6',
  type: 'DOOR',
  description: '6-variant door with fixed side panels and triple door opening',
  width: 4000,
  height: 2500,
  photoId: null,
  serviceNames: [],
  serviceIds: [],
  parameters: [
    // Frame profiles
    {
      positionId: 'top_frame_profile',
      type: 'PROFILE',
      width: 4000,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'bottom_left_frame_profile',
      type: 'PROFILE',
      width: 400,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_center_frame_profile',
      type: 'PROFILE',
      width: 800,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 1300, y: 2440, z: 0 },
    },
    {
      positionId: 'bottom_right_frame_profile',
      type: 'PROFILE',
      width: 300,
      height: frameThickness,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 3700, y: 2440, z: 0 },
    },
    {
      positionId: 'left_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 0, y: 0, z: 0 },
    },
    {
      positionId: 'right_frame_profile',
      type: 'PROFILE',
      width: frameThickness,
      height: 2500,
      thickness: 2,
      color: '#ffffff',
      material: '',
      materialId: null,
      position: { x: 3940, y: 0, z: 0 },
    },
    // Glass panels
    {
      positionId: 'left_glass_panel',
      type: 'GLASS',
      width: 340,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: frameThickness, y: frameThickness, z: 0 },
    },
    {
      positionId: 'left_door_top_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 400,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 400, y: frameThickness, z: 0 },
    },
    {
      positionId: 'left_door_glass_panel',
      type: 'GLASS',
      width: 900,
      height: 2040,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 400, y: 460, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'left_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 820, y: 920, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: -glassHingeWidth / 3, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 0, y: 2040 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_1_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 900 - glassLockWidth * 1.5, y: 2040 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'center_glass_panel',
      type: 'GLASS',
      width: 800,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 1300, y: frameThickness, z: 0 },
    },
    {
      positionId: 'right_door_glass_panel_1',
      type: 'GLASS',
      width: 800,
      height: 2040,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 2100, y: 460, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'left_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 720, y: 920, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_1_left_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: -glassHingeWidth / 3, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_1_left_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 0, y: 2040 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_1_right_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassLockWidth * 1.5, y: 2040 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'right_door_glass_panel_2',
      type: 'GLASS',
      width: 800,
      height: 2040,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 2900, y: 460, z: 0 },
      hardware: {
        handles: [
          {
            positionId: 'right_vertical_handle',
            type: 'VERTICAL_HANDLE',
            width: 40,
            height: 200,
            thickness: 10,
            color: '#ffffff',
            material: '',
            materialId: null,
            position: { x: 40, y: 920, z: 10 },
          },
        ],
        hinges: [
          {
            positionId: 'door_2_right_top_hinge_1',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassHingeWidth / 2, y: -glassHingeHeight / 2, z: 10 },
          },
          {
            positionId: 'door_2_right_bottom_hinge_2',
            type: 'HINGE',
            width: glassHingeWidth,
            height: glassHingeHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: 800 - glassHingeWidth, y: 2040 - glassHingeHeight, z: 10 },
          },
        ],
        locks: [
          {
            positionId: 'door_2_left_lock',
            type: 'LOCK',
            width: glassLockWidth,
            height: glassLockHeight,
            thickness: 10,
            color: '#C0C0C0',
            material: '',
            materialId: null,
            position: { x: glassLockWidth, y: 2040 - glassLockHeight, z: 10 },
          },
        ],
      },
    },
    {
      positionId: 'right_door_top_glass_panel',
      type: 'GLASS',
      width: 1600,
      height: 400,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 2100, y: frameThickness, z: 0 },
    },
    {
      positionId: 'right_glass_panel',
      type: 'GLASS',
      width: 240,
      height: 2380,
      thickness: 6,
      color: 'transparent',
      material: 'clear_glass',
      materialId: null,
      isDouble: false,
      position: { x: 3700, y: frameThickness, z: 0 },
    },
  ],
  doorConfiguration: {
    type: 'triple_door',
    totalDoorWidth: 2500,
    individualDoorWidth: [900, 800, 800],
    totalHandles: 3,
    openingDirection: 'multi_opening',
    hingePosition: 'multiple_split',
  },
}
